import { useQuery } from "@tanstack/react-query";
import { BRAND_BILLING_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useGetBrandBillingById(brandId: string, enabled: boolean = true, staleTime?: number) {
  const {
    data: brandBilling,
    isFetching: isBrandBillingFetching,
    isSuccess: isBrandBillingSuccess,
    error: brandBillingError,
    refetch: refetchBrandBilling,
  } = useQuery({
    queryKey: [...BRAND_BILLING_QUERY_KEY, brandId],
    queryFn: () => OrganisationService.getBrandBillingById(brandId),
    enabled: !!brandId && enabled,
    staleTime: staleTime
  });

  return {
    brandBilling,
    isBrandBillingFetching,
    isBrandBillingSuccess,
    brandBillingError,
    refetchBrandBilling,
  };
}
